import React from "react";
import {render} from "react-dom";
import {applyMiddleware, compose, createStore} from "redux";
import {Provider} from "react-redux";
import thunk from "redux-thunk";
import mwapi, {callApi, Schemas} from "./middleware/MittwaldApi";
import gtmMiddleware from "./middleware/GTM";
import AppWrapper from "./containers/AppWrapper";
import SimpleCheckout from "./containers/clientdatasimple/SimpleCheckout";
import reducers from "./reducers/index";
import {delve, findGetParameter} from "./util/util";
import {clearState, loadState, saveState} from "./localStorage/localStorage";
import "core-js/es5";
import "core-js/es6/array";
import "core-js/es6/object";
import "core-js/es6/string";
import "core-js/es7/object";
import "core-js/es7/array";

import createEngine from 'redux-storage-engine-localstorage'
import * as storage from 'redux-storage'
import filter from 'redux-storage-decorator-filter'
import debounce from 'redux-storage-decorator-debounce'
import {_auth, _useConfiguration} from "./selectors/GetParam";
import {APP_MODE_ACCESSORY, APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_AUTHENTICATED_ORDER, APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE} from "./constants/General";
import {agencyServerArticleNumber, cartApiEndpoint, lsConfigurator, lsPrefix} from "./config/Config";
import {isAgencyServer} from "./selectors/ArticleNumbers";
import {isMode} from "./selectors/Mode";
import {setEngine} from "./util/engine";

import "../public/css/App.css"
import {getMainArticleByItems, getMainArticleInCart} from "./selectors/Cart";

//todo: move findGetParameter calls to GetParam.js
// **************************************************************************************************************

// **************************************************************************************************************
try {
    // set Domain for cross-origin policy
    if (document.domain.includes('ddev.site')) {
        document.domain = "mittwald.ddev.site"
    } else {
        document.domain = "mittwald.de"
    }
} catch (e) {
}


/** id of the cart preset */
const presetId = findGetParameter('preset')
/** id for affiliate links */
const affiliateId = findGetParameter('aid')
/** clear persisted state on startup? */
const clearStateFlag = findGetParameter('clear')
/** standalone simple mode? */
const simpleMode = findGetParameter('simple')

/** init params */
let baseArticleId = findGetParameter('article')
let baseAddon = findGetParameter('addon')
let initialItemIds = findGetParameter('addons')
let initialDomainNames = findGetParameter('domains')
let initialCartId = findGetParameter('cart')
let initialBackup = findGetParameter('backup')

const initialPromotionCode = findGetParameter('promotion')

let engine
let localStorageName

/**
 * if _useConfiguration is set, map the data from the local storage to an actual entrypoint with get parameters
 */
if (baseArticleId !== agencyServerArticleNumber && _useConfiguration) {
    // set base article by configurator config
    const configuratorData = JSON.parse(localStorage.getItem(lsConfigurator + "_" + _useConfiguration));

    if (configuratorData) {

        //localStorage.removeItem(lsConfigurator + "_cms");
        const article = delve(configuratorData, "form.projectSelection.values.article");
        const storageArticle = delve(configuratorData, "form.projectSelection.values.storage");
        const backup = delve(configuratorData, "form.projectSelection.values.backup");

        let historyState = location.pathname;

        if (article) {
            baseArticleId = "" + article;
            historyState += "?article=" + baseArticleId;
        } else {
            // default fallback article
            baseArticleId = "70000";
            historyState += "?article=" + baseArticleId;
        }

        if (storageArticle) {
            initialItemIds = "" + storageArticle;
            historyState += "&addons=" + initialItemIds;
        }

        if (backup) {
            initialBackup = "" + backup;
            historyState += "&backup=" + initialBackup;
        }

        history.replaceState(null, null, historyState)
    }
}

if (isMode(APP_MODE_PRODUCT_CHANGE)) {

    localStorageName = lsPrefix + "product_change"

} else if (isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT)) {

    localStorageName = lsPrefix + "add_project"

} else if (isMode(APP_MODE_OUTSOURCING)) {

    localStorageName = lsPrefix + "outsourcing"

} else if (isMode(APP_MODE_AUTHENTICATED_ORDER)) {

    localStorageName = lsPrefix + "authenticated_order"

} else if (isMode(APP_MODE_ACCESSORY)) {

    localStorageName = lsPrefix + "addon"

} else {

    if (baseArticleId) {
        localStorageName = lsPrefix + baseArticleId
    } else if (baseAddon) {
        localStorageName = lsPrefix + "addon_" + baseAddon
    } else {
        localStorageName = lsPrefix + "preset"
    }

}


const initApp = (baseArticleId, baseAddon) => {

    /*if (!baseArticleId && !baseAddon) {
        return
    }*/

    // MODIFIY STATE TO LOAD
    let stateToLoad

    stateToLoad = loadState(localStorageName)

    let store

    let initialArticles = initialItemIds ? initialItemIds.split(",") : []
    if (baseAddon) {
        initialArticles.unshift(baseAddon)
    }

    const isNewAgencyServerProject = isAgencyServer(baseArticleId) && !!localStorage.getItem(lsConfigurator + "_shared") && _useConfiguration;

    // check if URL matches
    if (stateToLoad && stateToLoad.cart && !clearStateFlag && !simpleMode) {
        /* eslint-disable */
        const tokenNotExpired = stateToLoad.token && new Date().getTime() < new Date(stateToLoad.token.expires).getTime()
        const presetIdsMatching = (presetId && presetId === stateToLoad.cart.initParams.createdFromPreset)
        const mainArticleToLoad = getMainArticleInCart(stateToLoad);

        // check if there is an existing cart that matches the criteria
        if (// no preset id or matching preset ids
            (!presetId || presetIdsMatching)

            && stateToLoad && stateToLoad.cart && stateToLoad.cart.initParams

            // if init params are different, reset state
            && (
                (
                    // if initial cart id, check if it is the latest stored cart id
                    (initialCartId && stateToLoad.cart.id === initialCartId)
                )
                ||
                // check if initParams are unset or if set, matching with the cart properties of the persisted state
                (
                    // unset || set and equal
                    ((!initialItemIds && (!stateToLoad.cart.initParams.initialArticles || Array.isArray(stateToLoad.cart.initParams.initialArticles) && stateToLoad.cart.initParams.initialArticles.length === 0)) || (stateToLoad.cart.initParams && Array.isArray(stateToLoad.cart.initParams.initialArticles) && stateToLoad.cart.initParams.initialArticles.join(",") === initialArticles.join(",")))
                    &&
                    // unset || set and equal
                    ((!initialDomainNames && (!stateToLoad.cart.initParams.initialDomains || Array.isArray(stateToLoad.cart.initParams.initialDomains) && stateToLoad.cart.initParams.initialDomains.length === 0)) || (stateToLoad.cart.initParams && Array.isArray(stateToLoad.cart.initParams.initialDomains) && stateToLoad.cart.initParams.initialDomains.join(",") === initialDomainNames))
                    &&
                    // unset || set and equal
                    ((!initialPromotionCode && !stateToLoad.cart.initParams.initialPromotionCode) || (stateToLoad.cart.initParams && stateToLoad.cart.initParams.initialPromotionCode === initialPromotionCode))
                    &&
                    ((!initialBackup && !stateToLoad.cart.initParams.initialBackup) || (stateToLoad.cart.initParams.initialBackup === initialBackup))
                    &&
                    // unset || set and equal
                    ((!baseAddon && !stateToLoad.cart.initParams.baseAddon) || (stateToLoad.cart.initParams && stateToLoad.cart.initParams.baseAddon === baseAddon))
                )
            )

            // verify that stored cart is matching articleNumber
            &&
            (
                (mainArticleToLoad === "" + baseArticleId)
                ||
                (!baseArticleId && baseAddon)
            )
            // reset state on new affiliate value
            && (!affiliateId || (affiliateId && stateToLoad.cart.commission === "" + affiliateId))

            // reset state if token expired
            && tokenNotExpired

            // never use existing cart if auth is passed
            && !_auth

            // never use existing cart if new agency server configuration was found in localstorage
            && !isNewAgencyServerProject

        ) {

            initialCartId = stateToLoad.cart.id

            // set basearticle id if all criteria are matched, important for /?addon= entry point
            if (mainArticleToLoad && baseAddon) {
                stateToLoad.crossSelling = {}
                stateToLoad.crossSelling.selectedArticle = mainArticleToLoad
            }
            if (stateToLoad.cart.initParams.initialArticles && Array.isArray(stateToLoad.cart.initParams.initialArticles) && stateToLoad.cart.initParams.initialArticles.length > 0) {
                initialItemIds = stateToLoad.cart.initParams.initialArticles.join(",")
            }

            if (stateToLoad.cart.initParams.initialDomains && Array.isArray(stateToLoad.cart.initParams.initialDomains) && stateToLoad.cart.initParams.initialDomains.length > 0) {
                initialDomainNames = stateToLoad.cart.initParams.initialDomains.join(",")
            }
        } else {

            initialCartId = false

        }

        // restore token if not expired
        if (tokenNotExpired && !_auth) {

            let newState = {
                token: stateToLoad.token,
                outsourcing: stateToLoad.outsourcing,
                /*software: stateToLoad.software*/
            }

            if (initialCartId) {
                newState = Object.assign({}, newState, {
                    clientDataStep: stateToLoad.clientDataStep,
                    appState: stateToLoad.appState,
                    cart: {
                        id: initialCartId
                    }
                })
            }

            if (stateToLoad.crossSelling) {
                newState.crossSelling = stateToLoad.crossSelling
            }

            saveState(localStorageName, newState)

        } else {
            // reset state since new tokens won't have access to previous carts
            clearState(localStorageName)
        }
        /* eslint-enable */

    } else {
        // reset state if different preset, different article or different commission
        clearState(localStorageName)
    }

    engine = debounce(filter(createEngine(localStorageName), ['token', 'cart', 'clientDataStep', ['crossSelling', 'selectedArticle'], ['outsourcing', 'initialCommission']], null), 1500)

    const storageMiddleware = storage.createMiddleware(engine)
    const middleware = [thunk, mwapi, gtmMiddleware, storageMiddleware]
    const load = storage.createLoader(engine);

    setEngine(engine);

    // will be passed to reducer via init action and stored 1:1
    const initParams = {
        createdFromPreset: presetId ? presetId : false,
        initialArticles: initialArticles,
        initialBackup: initialBackup,
        initialDomains: initialDomainNames ? initialDomainNames.split(",") : [],
        initialPromotionCode: initialPromotionCode ? initialPromotionCode : false,
        baseAddon: baseAddon ? baseAddon : false,
        //lockInitialAddons: initialPromotionCode ? true : false
        lockInitialAddons: false,
        minSelectedUsageGB: delve(stateToLoad, "cart.initParams.minSelectedUsageGB") ? delve(stateToLoad, "cart.initParams.minSelectedUsageGB") : false
    }

    const renderApp = () => {
        render(
            <Provider store={store}>
                {simpleMode ?
                    <SimpleCheckout
                        baseArticleId={baseArticleId}
                        initialCartId={initialCartId ? initialCartId : ""}
                        initParams={initParams}
                    /> :
                    <AppWrapper
                        baseAddon={baseAddon}
                        initialCartId={initialCartId ? initialCartId : ""}
                        baseArticleId={baseArticleId}
                        initParams={initParams}
                    />
                }
            </Provider>,
            document.getElementById('root')
        )
    }

    if (process.env.NODE_ENV === "development") {

        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        const enhancer = composeEnhancers(
            applyMiddleware(...middleware)
        );

        store = createStore(
            reducers,
            {},
            enhancer
        )

    } else {

        store = createStore(
            reducers,
            applyMiddleware(...middleware)
        )

    }

    store.subscribe(() => {
        if (store.getState().appState.orderComplete) {
            clearState(localStorageName)
        }
    })


    load(store).then((newState) => {
        renderApp()
    })

}

// **************************************************************************************************************

if (baseArticleId) {

    initApp(baseArticleId, "")

} else if (baseAddon) {

    initApp("", baseAddon)

} else if (presetId) {

    let temporaryToken = false

    callApi(`authenticate`, Schemas.BEARER_TOKEN, 'POST', false, {}).then(
        response => {

            temporaryToken = response.entities.tokens.token.token

            // create temporaryCart with temporaryToken

            callApi(`${cartApiEndpoint}/${presetId}`, Schemas.CARTSCHEMA, 'POST', temporaryToken, {}).then(
                response => {
                    baseArticleId = getMainArticleByItems(response.result.items);
                    if (!baseArticleId) {
                        alert("Ein Fehler ist aufgetreten. Bitte lade die Seite neu.")
                    }
                    initApp(baseArticleId, "")
                },
                error => {
                    alert("Ein Fehler ist aufgetreten. Bitte lade die Seite neu.")
                }
            )

        },
        error => {
            alert("Ein Fehler ist aufgetreten. Bitte lade die Seite neu.")
        }
    )

} else {

    if (
        isMode(APP_MODE_OUTSOURCING) ||
        isMode(APP_MODE_AUTHENTICATED_ORDER) ||
        isMode(APP_MODE_PRODUCT_CHANGE) ||
        isMode(APP_MODE_ACCESSORY) ||
        isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT)
    ) {
        initApp();
    }
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/